// Use This URL for testing
const URL = "ecogreencertificates.com";

export const BASE_URL = `https://${URL}/api/`;
export const DOMAIN = `https://${URL}`;
export const MAX_COLS = 30;
export const ID_BASE = 1;
export const SRF_ID_BASE = 1;
export const MAX_SIZE_MB = 3;

// TODO: need to move to DB
export const BANK_DETAILS = {
  "Bank Name": "State Bank OF India, CBD Belapur Navi Mumbai",
  "Bank A/c. No.": "39813124209",
  "IFSC Code": "SBIN0061520",
};

export const weightUncertaintySupportiveValues = {
  barometer: 2.4,
  tempIndicator: 0.58,
  rhIndicator: 1.74,
  weightBox: 7950,
};

export const G_Value = 9.80665;

export const GST_NUMBER = "27DSVPK5381Q1ZH";

export const DISABLED_MODULE =["Courier Register","Expenses","Audit","Document Upload","Purchase"
,"DUC Master","Department","Request Form","CoordinatesAddress","Settings","Datasheet Template","Discipline","ClientsUser","OfflineMode","WCR Report","Training Resources","Department Analytics","Inward Register","SRF_ULR_Register","Uncertainty","External Calibration","reservedSrf","emailOtpVerification","DatasheetReadingsAudit","locationTracking","Uncertainty","UULIMS","Independent Due","Task Management","Inward Pending Items","Thread Ring/Plug","Tapper Thread Ring","Plain Plug/ Snap Gauge"]; 

export const DEVICE_TYPE = ["desktop", "tablet", "mobile"];

export const LATEST_HASH = "89e09b5893d3f6da022ade0dbd903a52d47c63c6";

export const DEFAULT_MAX_PRECISION = 10;

export const TIME_ZONE_OFFSET = "";
// - INTERVAL 3 HOUR - INTERVAL 30 MINUTE

export const UnicodeCompany = "EGL";
